export const getDashboardAccess = () => {
  try {
    const data = localStorage.getItem("dashboard_access");
    return data ? JSON.parse(data) : {};
  } catch (error) {
    console.error("Access parse error:", error);
    return {};
  }
};

export const hasAccess = (key) => {
  const access = getDashboardAccess();
  return access?.[key] === true;
};